import { render } from "./voucher-recipient.vue?vue&type=template&id=c16cdfe0"
import script from "./voucher-recipient.vue?vue&type=script&lang=js"
export * from "./voucher-recipient.vue?vue&type=script&lang=js"
script.render = render

export default script